export const FETCH_WISHLIST = 'FETCH_WISHLIST';
export const FETCH_WISHLIST_SUCCESS = 'FETCH_WISHLIST_SUCCESS';
export const FETCH_WISHLIST_FAILED = 'FETCH_WISHLIST_FAILED';

export const ADD_TO_WISHLIST = 'ADD_TO_WISHLIST';
export const ADD_TO_WISHLIST_SUCCESS = 'ADD_TO_WISHLIST_SUCCESS';
export const ADD_TO_WISHLIST_FAILED = 'ADD_TO_WISHLIST_FAILED';

export const REMOVE_FROM_WISHLIST = 'REMOVE_FROM_WISHLIST';
export const REMOVE_FROM_WISHLIST_SUCCESS = 'REMOVE_FROM_WISHLIST_SUCCESS';
export const REMOVE_FROM_WISHLIST_FAILED = 'REMOVE_FROM_WISHLIST_FAILED';

export const WISHLIST_QUEUE_UPDATED = 'WISHLIST_QUEUE_UPDATED';
export const ADD = 'add';
export const REMOVE = 'remove';

export interface WishlistResponse {
    data?: {
        products: Array<string>;
        errors: [];
        success: boolean;
    };
}

export interface WishlistState {
    isFetching: boolean;
    didInvalidate: boolean;
    products: Array<string>;
    count: number;
    error?: any;
}

export interface WishlistQueueState {
    todo: string | null;
    simpleSku: string | null;
}

export interface WishlistQueueActionTypes {
    type: typeof WISHLIST_QUEUE_UPDATED;
    payload: WishlistQueueState;
}
